<template>
    <ViewParent/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewParent from "@/components/Parent/ViewParent.vue";

    export default defineComponent({
      name: "ViewParentPage",
      components: {
        
        ViewParent,
      },
    });
  </script>